import { createContext } from "react";
import { CsrStrategy } from "src/api/client-api/csrStrategy/useGetAllStrategy";

export type SettingsStrategyInitialValues = {
    strategy: CsrStrategy | undefined;
};
export const SettingsStrategyContext = createContext<SettingsStrategyInitialValues | null>(null);
